import styles from '../../styles/components/blogs/BlogContent.module.css';
import { sanitizeHtml } from '../../utils/helpers/sanitize';
import { AuthorSection } from '../sections';

const BlogContent = ({ blog, isLoading = false }) => {
    if (!blog && !isLoading) return null;


    return (
        <article className={styles.blogContent}>
            {isLoading ? (
                <div className={styles.blogContentSkeleton}>
                    <div className={styles.skeletonHeader}></div>
                    <div className={styles.skeletonParagraph}></div>
                    <div className={styles.skeletonParagraph}></div>
                    <div className={styles.skeletonParagraph}></div>
                    <div className={styles.skeletonParagraph}></div>
                    <div className={styles.skeletonParagraph}></div>
                </div>
            ) : (
                <>
                    <div 
                        className={`${styles.blogDetail} blogDetail`}
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(blog.Detail) }}
                    />
                    <AuthorSection author={blog.author ?? blog.Author} />
                </>
            )}
        </article>
    );
};

export default BlogContent;
